export default __webpack_public_path__ + "src/assets/images/start-video-search.png";